// extracted by mini-css-extract-plugin
export default {"container":"Header_container__2T56a","tab_menu":"Header_tab_menu__mNcs5"};